<template>
	<section>
		<b-modal
			ref="modalLogin"
			ok-title="Acceder"
			hide-header
			hide-footer
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-backdrop
			no-fade
			>
			<b-overlay :show="loading" no-wrap></b-overlay>
			<div class="text-center">
				<img :src="logo" style="max-width: 200px">
				<h3 class="text-center">Recupera tu contraseña</h3>
			</div>
			<hr>
			<b-form v-if="!resetOk" ref="loginForm" @submit="onSubmit">
			<div class="row justify-content-md-center">
				<div class="col-sm-8">
					<b-form-group label="Correo electronico">
						<b-form-input
							v-model="form.email"
							type="text"
							required
						></b-form-input>
					</b-form-group>
				</div>
			</div>
				<p class="text-danger" v-if="error">Ocurrio un error, intentalo mas tarde</p>
				<br>
				<div class="text-center">
					<b-button variant="primary" type="submit" >Recuperar contraseña</b-button>
					<br>
					<br>
					<a href="/login" @click="$root.setRouteEvt">Regresar</a>
				</div>
			</b-form>
			<div v-else>
				<p>Se ha enviado un correo a tu email para recuperar tu contraseña, sigue las instrucciones.</p>
				<a href="/login" @click="$root.setRouteEvt">Iniciar Sesión</a>
			</div>
		</b-modal>
	</section>
</template>

<script>
import api from '../../../api.js'
import logo from '../../../assets/logo-sc-negro.png'

export default {
  components: {  },
  data(){
	return {
		resetOk:false,
		logo,
		form : {
			email:'',
		},
		error:false,
		loading:false,
	}
  },
  methods:{
	resetPass(event){
		console.log(event)
	},
	onSubmit(evt){
		evt.preventDefault();
		this.error = false;
		this.loading = true;
		api(this).post('/auth/reset-password',this.form).then(() => {
			this.resetOk = true
			this.loading = false;
		}).catch(()=>{
			this.loading = false;
			this.error = true;
		}).then(()=>{
		});
	},
  },
  mounted(){
	this.$refs['modalLogin'].show();
  }
}
</script>

<style>

</style>
